// extracted by mini-css-extract-plugin
export default {"renderer":"_1uQbT"};